import React from 'react';
import PracticeDetailPage from './PracticeDetailPage';

export default function PracticeEpaHhera() {
  return (
    <PracticeDetailPage
      practiceId="epa-hhera"
      canonicalPath="/practice/epa-human-health-environmental-risk"
    />
  );
}
